// TODO - Documentar

import { useLocation, useNavigate } from 'react-router';
import { emulateTab } from 'emulate-tab';
import * as con from "../../GlobalConstants"
import { RefModelParameterHook } from './ModelParameterHooks';
import { EditApplicationParameterHook } from './ApplicationParametersHooks';
import { useCallback } from 'react';


/**
 * Hook for navegation
 */
export function NavigationHook() {
    const location = useLocation();
    const navigate = useNavigate();    
    const modelParametersSaved = RefModelParameterHook(con.MODEL_PARAMETERS_SAVED)
    const setPendingRoute = EditApplicationParameterHook(con.PENDING_ROUTE)
    const setShowUnsavedModal = EditApplicationParameterHook(con.SHOW_UNSAVED_MODAL)

    const guardedNavigate = useCallback((path) => {
        if (modelParametersSaved === con.PENDING) {
            setPendingRoute(path)
            setShowUnsavedModal(true)
        } else {
            navigate(path)
        }
    }, [modelParametersSaved, navigate, setPendingRoute, setShowUnsavedModal])

    return [location.pathname, guardedNavigate]
}

/**
 * Ref for current page
 */
 export function RefCurrentPage() {

    const location = useLocation();  

    return(location.pathname)

}

/**
 * Ref for set current page
 */
export function RefSetCurrentPage() {
    const navigate = useNavigate()
    return navigate
}


export const TabNavegationHandler = (event) =>
{
   if(event.keyCode === 13 )// Enter
   {            
       emulateTab();
       event.preventDefault();

   }
   if(event.keyCode === 24 )// Arrow up
   {            
       emulateTab.backwards();
       event.preventDefault();

   }
   if(event.keyCode === 25 )// Enter
   {            
       emulateTab();
       event.preventDefault();

   }
}